module.exports = __webpack_public_path__ + "img/back.a3766139.jpg";